export default "__VITE_ASSET__DnlpGdhV__"